var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Long from "long";
import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
import { utilCompatibility } from "../../../utils/utilCompatibility";
import { utilTime } from "../../../utils/utilTime";
import { Icon } from "../../generic/icon/Icon";
import { IdIcon } from "../../generic/icon/IdIcon";
import { NumberFormat } from "../../generic/number-format/NumberFormat";
import { TypeNumberFormat } from "../../generic/number-format/TypeNumberFormat";
var BuildingStats = /** @class */ (function (_super) {
    __extends(BuildingStats, _super);
    function BuildingStats() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getConstructionTime = function () {
            var constructionTime = _this.props.constructionTime;
            var gridStyle = utilCompatibility.getMsGridPositions(0, 2);
            return (React.createElement("div", { className: "building-information__item", style: gridStyle },
                React.createElement(Icon, { icon: IdIcon.ConstructionTimeIcn, styleId: IdStyles.IconMedium }),
                React.createElement("div", { className: IdStyles.TextBoldAccent }, utilTime.format(constructionTime))));
        };
        _this.getXpInfo = function () {
            var _a = _this.props, xpInfo = _a.xpInfo, buffXpAmount = _a.buffXpAmount;
            var gridStyle = utilCompatibility.getMsGridPositions(1, 2);
            return (xpInfo && (React.createElement("div", { className: "building-information__item", style: gridStyle },
                React.createElement(Icon, { icon: IdIcon.XpIcn, styleId: IdStyles.IconMedium }),
                React.createElement("div", { className: IdStyles.TextBoldAccent },
                    React.createElement(NumberFormat, { amount: xpInfo.amount }),
                    React.createElement(NumberFormat, { amount: buffXpAmount || Long.ZERO, format: TypeNumberFormat.AddExceptZero })))));
        };
        _this.getHappiness = function () {
            var happiness = _this.props.happiness;
            var gridStyle = utilCompatibility.getMsGridPositions(2, 2);
            return happiness ? (React.createElement("div", { className: "building-information__item", style: gridStyle },
                React.createElement(Icon, { icon: IdIcon.HappinessPositiveIcn, styleId: IdStyles.IconMedium }),
                React.createElement("div", { className: IdStyles.TextBoldAccent },
                    React.createElement(NumberFormat, { amount: happiness, format: TypeNumberFormat.Add })))) : (undefined);
        };
        _this.getWorkers = function () {
            var workers = _this.props.workers;
            var gridStyle = utilCompatibility.getMsGridPositions(3, 2);
            return workers && workers > 0 ? (React.createElement("div", { className: "building-information__item", style: gridStyle },
                React.createElement(Icon, { icon: IdIcon.WorkersIcn, styleId: IdStyles.IconMedium }),
                React.createElement("div", { className: IdStyles.TextBoldAccent },
                    React.createElement(NumberFormat, { amount: workers, format: TypeNumberFormat.Add })))) : (undefined);
        };
        return _this;
    }
    BuildingStats.prototype.render = function () {
        return (React.createElement("div", { className: "building-information" },
            this.getConstructionTime(),
            this.getXpInfo(),
            this.getHappiness(),
            this.getWorkers()));
    };
    return BuildingStats;
}(React.PureComponent));
export { BuildingStats };



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/BuildingStats.tsx
// module id = 938
// module chunks = 3